import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';
import { CloseOutlined, FileTextOutlined } from '@ant-design/icons';
import { Image as AntImage } from 'antd';
import React from 'react';
import './SortableThumbnail.css';

export default function SortableThumbnail({ id, index, src, file, onRemove }) {
  const isMail =
    file.name?.toLowerCase().endsWith('.eml') || file.name?.toLowerCase().endsWith('.msg');

  const { setNodeRef, transform, transition } = useSortable({
    id,
    disabled: isMail, //Dragging is not allowed in emails
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const formatFileName = fileName => {
    if (!fileName) return '';
    if (fileName.length <= 20) return fileName;
    return `${fileName.substring(0, 20)}...`;
  };

  return (
    <div ref={setNodeRef} style={style} className="sortable-thumbnail">
      {/* ================= Image layer (truly clickable) ================= */}
      {!isMail ? (
        <div className="thumbnail-image-container">
          {/* The image itself - covers the entire area but allows for clicks */}
          <div
            className="thumbnail-image-layer"
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <AntImage
              width={70}
              height={70}
              src={src}
              preview={{ src: src }}
              className="thumbnail-image"
            />
          </div>
        </div>
      ) : (
        /* ================= mail card ================= */
        <div className="mail-card">
          <FileTextOutlined className="mail-icon" />
          <div className="mail-name">{formatFileName(file.name)}</div>
        </div>
      )}

      {/* ================= Sequential numbering (excluding events) ================= */}
      <div className="thumbnail-index">{index + 1}</div>

      {/* ================= Delete button (the only clickable overlay) ================= */}
      <CloseOutlined
        onClick={e => {
          e.stopPropagation();
          onRemove();
        }}
        className="thumbnail-delete"
      />
    </div>
  );
}
